import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
/**
 * /
 * param {any} divRef - current div 
 * param {any} ndx -  data
 */
/**
 dc.js chart  template 
 */
const financestreamChartFunc = (divRef, ndx) => {
    // define chart dimension
    const dimension = ndx.dimension((d) => d.financeStream);
    // Create chart object 
  const finceStreamChart = dc.selectMenu(divRef);
    finceStreamChart
    .dimension(dimension) // assign chart  dimension
        .group(dimension.group().reduceCount())
        // get the value of the filter 
    .on("filtered", function (chart, filter) {
      var sel = chart.filterPrinter()(chart.filters());
      window.IFINANCESTREAM = sel
      // console.log("selected filters are:" + sel);
    })
        // display title on hover
    .title(function (d) {
      return d.key;
    })
    .controlsUseVisibility(true);

    return finceStreamChart;
};

export const FinanceStreamChart = (props) => (
  <ChartTemplate
        chartFunction={financestreamChartFunc}
    // title="Gender of Financing Recipient"
    name="Select Finance Stream"
  />
);
